import axios from 'axios';
import { shopManagerApi } from './index';


const axiosApi = axios.create({
  withCredentials: true,
  baseURL: shopManagerApi
});

axiosApi.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error?.response?.status == 401) {
    window.location.href = '/login';
  }

  return Promise.reject(error);
});

export default axiosApi;
